import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet><ngx-spinner type="eden-box" size="medium" color="#fefefe"></ngx-spinner>`
})
export class RootComponent {

}
